module.exports = __webpack_public_path__ + "0d2a8937dceb2d0b60e521564be05816.pdf";